import React from 'react'
import "./Background.css"
import Education from "./Education/Education";
import Experience from "./Experience/Experience";
import Button from '@mui/material/Button';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';


function Background() {


    const [showED, setShowED] = React.useState(false);
    const onClickED = () => {
        setShowED(true);
        setShowEX(false)
    };
    const [showEX, setShowEX] = React.useState(true);
    const onClickEX = () => {
        setShowEX(true);
        setShowED(false);
    }

    return (
        <div className="Background">
            <h1>Background</h1>
            
                <div className="Content">
                    <div className="buttons">
                    <Button variant="outlined"  onClick={onClickEX}> my Experiences <WorkIcon/></Button>
                    <Button variant="outlined"  onClick={onClickED}> my Qualifications <SchoolIcon/> </Button>
                    </div>
                    <div className="backGround">
                    {showED ? <Education/>: null}
                    {showEX ? <Experience/>: null}
                    </div>
                </div>
         </div>
            
    )
};

export default Background;
